export default __webpack_public_path__ + "static/media/synthesis.c8bede72.jpg";